import { render, staticRenderFns } from "./CheckListDetail.vue?vue&type=template&id=5b649e56&scoped=true"
import script from "./CheckListDetail.vue?vue&type=script&lang=js"
export * from "./CheckListDetail.vue?vue&type=script&lang=js"
import style0 from "./CheckListDetail.vue?vue&type=style&index=0&id=5b649e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b649e56",
  null
  
)

export default component.exports